import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { PACKAGES } from "./data";

export default function Packages() {
  const select = (name) => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
    window.dispatchEvent(new CustomEvent("select-package", { detail: name }));
  };

  return (
    <section id="packages" data-testid="packages-section" className="relative py-28 md:py-40">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="mb-16 max-w-2xl">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">Packages</span>
          <h2 className="mt-5 font-serif font-light text-4xl sm:text-5xl md:text-6xl tracking-tight leading-none text-foreground">
            Transparent scope. No surprise fees.
          </h2>
          <p className="mt-4 font-mono text-xs uppercase tracking-[0.15em] text-muted-foreground" data-testid="packages-subnote">
            Sign up for monthly or one-time service! Cancel anytime!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 border border-border">
          {PACKAGES.map((p, i) => (
            <motion.div
              key={p.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ delay: i * 0.1, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className={`relative p-8 md:p-10 flex flex-col border-border ${
                i > 0 ? "border-t md:border-t-0 md:border-l" : ""
              } ${p.featured ? "bg-primary text-primary-foreground" : "bg-card"}`}
              data-testid={`package-card-${i}`}
            >
              <div className="flex items-center justify-between">
                <span className={`font-mono text-xs uppercase tracking-[0.2em] ${p.featured ? "text-primary-foreground/70" : "text-muted-foreground"}`}>
                  {p.tag}
                </span>
              </div>
              <h3 className={`mt-6 font-serif text-3xl md:text-4xl tracking-tight ${p.featured ? "text-primary-foreground" : "text-foreground"}`}>
                {p.name}
              </h3>
              <div className="mt-4 flex items-baseline gap-2">
                <span className={`font-serif font-light ${p.price === "Custom" ? "text-3xl" : "text-5xl"} ${p.featured ? "text-primary-foreground" : "text-foreground"}`}>{p.price}</span>
                <span className={`text-sm ${p.featured ? "text-primary-foreground/60" : "text-muted-foreground"}`}>{p.unit}</span>
              </div>

              <ul className="mt-8 space-y-3 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3">
                    <Check size={16} strokeWidth={2} className={`mt-0.5 shrink-0 ${p.featured ? "text-accent" : "text-primary"}`} />
                    <span className={`text-sm leading-relaxed ${p.featured ? "text-primary-foreground/85" : "text-muted-foreground"}`}>{f}</span>
                  </li>
                ))}
              </ul>

              <button
                data-testid={`package-select-${i}`}
                onClick={() => select(p.name)}
                className={`mt-10 rounded-full px-6 py-3.5 text-sm transition-transform duration-200 hover:-translate-y-0.5 ${
                  p.featured
                    ? "bg-primary-foreground text-primary"
                    : "bg-primary text-primary-foreground"
                }`}
              >
                {p.price === "Custom" ? "Request a Quote" : "Select Plan"}
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
